import { render, staticRenderFns } from "./ProducerContract.vue?vue&type=template&id=5c9a0a50&scoped=true&lang=true"
import script from "./ProducerContract.vue?vue&type=script&lang=js"
export * from "./ProducerContract.vue?vue&type=script&lang=js"
import style0 from "./ProducerContract.vue?vue&type=style&index=0&id=5c9a0a50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9a0a50",
  null
  
)

export default component.exports